import Page from 'components/ui/Page'

const ComingSoon = () => {
    return <Page>...</Page>
}

export default ComingSoon
